<template>
  <el-container>
    <el-header>

      <div class="toplogo">
        <img alt="" src="static/logo.jpg"> 
      </div>
      <div class="navimenu">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">实验中心</el-menu-item>
          <el-menu-item index="2"><router-link :to="{path: '/apply'}" style="text-decoration: none;">孵化申请</router-link></el-menu-item>
        </el-menu>
      </div>
      <div class="topmenu">
        <span @click="loginWarn" style="cursor: pointer;"><i class="el-icon-s-custom" style="margin-right: 5px"></i>登录</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="regWarn" style="cursor: pointer;"><i class="el-icon-s-check" style="margin-right: 5px"></i>注册</span>
      </div>
      <div class="topimg"><img alt="" src="static/fuhuajidi.jpg" ></div>


    </el-header>
    <el-main style="padding-top: 0; text-align: center;">
      <el-carousel height="400px">
        <!-- <el-carousel-item>
          <h3 class="small"><img alt="" src="static/banner1.jpg" width="100%" height="400px"></h3>
        </el-carousel-item> -->
        <el-carousel-item>
          <h3 class="small"><img alt="" src="static/banner2.jpg" width="100%" height="400px"></h3>
        </el-carousel-item>
      </el-carousel>
      <div class="cardrow">
        <el-tabs type="border-card">
          <el-tab-pane>
            <span slot="label"><i class="el-icon-menu"></i> &nbsp;&nbsp;课程目录&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-card :body-style="{ padding: '10px' }">
                    <img src="static/reli.jpg" class="image" width="100%">
                    <div style="padding: 5px; text-align: left">
                      <span>《工程热力学虚拟仿真实验》 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      <div class="bottom clearfix">
                        <i class="el-icon-view"></i> {{ relicount }}次
                        <el-button class="button" @click="jumpToLab('/relixue/login')">进入实验</el-button>
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card :body-style="{ padding: '10px' }">
                    <img src="static/gaoya.jpg" class="image" width="100%">
                    <div style="padding: 5px; text-align: left">
                      <span>《电力变压器高压绝缘特性虚拟仿真实验》</span>
                      <div class="bottom clearfix">
                        <i class="el-icon-view"></i> N/A 次
                        <el-button class="button" @click="jumpToLab('/gaoya/login')">进入实验</el-button>
                      </div>
                    </div>
                  </el-card>
                </el-col>

              </el-row>
          </el-tab-pane>
          <el-tab-pane><span slot="label"><i class="el-icon-s-opportunity"></i>&nbsp;&nbsp;使用指南&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <div style="height: 300px; padding-left: 30px">
              <el-steps direction="vertical" :active="6">
                <el-step title="注册账号" icon="el-icon-s-check" description="教师账号请联系校虚拟仿真实验中心开通账号；学生通过指导老师提交账号开通申请。"></el-step>
                <el-step title="检查环境" icon="el-icon-document-checked" description="必须为64位操作系统，浏览器兼容性:IE10以上, 火狐 Firefox-55.0以上, 谷歌Chrome 60.0 以上, 搜狗/360浏览器(高速模式)等。根据实验不同，安装好不同插件。"></el-step>
                <el-step title="教师指导" icon="el-icon-message-solid" description="实验前教师需对实验场景和实验参数进行设定，并将实验目的、实验方法下发给学生。"></el-step>
                <el-step title="学生操作" icon="el-icon-s-platform" description="学生按照实验指导老师的指令，登录系统，打开虚拟仿真环境进行操作。"></el-step>
                <el-step title="提交结果" icon="el-icon-s-promotion" description="学生在退出或者中心实验前，一般需要确保实验操作结果已提交（大部分虚拟仿真实验课程已会自动记录操作过程和结果，仍有少数情况下需要提交）。"></el-step>
                <el-step title="结果分析" icon="el-icon-s-marketing" description="实验指导教师在学生操作实验完毕后，由系统或者人工给与评价。"></el-step>
              </el-steps>
            </div>
          </el-tab-pane>
          <el-tab-pane><span slot="label"><i class="el-icon-s-help"></i>&nbsp;&nbsp;合作单位&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <div style="height: 300px; padding-left: 30px">
              <el-row :gutter="20">
                <el-col :span="6"><div class="grid-content bg-purple"></div><img alt="" src="static/ilab-x.png" width="100%"></el-col>
                <el-col :span="6"><div class="grid-content bg-purple"></div><img alt="" src="static/tebiandiangong.jpg" width="100%"></el-col>
                <el-col :span="6"><div class="grid-content bg-purple"></div><img alt="" src="static/huawei.jpg" width="100%"></el-col>
                <el-col :span="6"><div class="grid-content bg-purple"></div><img alt="" src="static/qinghua.jpg" width="100%"></el-col>
                <el-col :span="6"><div class="grid-content bg-purple"></div><img alt="" src="static/zhongnan.jpg" width="100%"></el-col>
                <el-col :span="6"><div class="grid-content bg-purple"></div><img alt="" src="static/unit3d.jpg" width="100%"></el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>

    <el-footer>Copyright 2020-2021 湖南交通工程学院  版权所有  All rights reserved <img src="https://xyt.xinchacha.com/img/icon/icon8.png" style="height:30px; width:98px; position:relative; top:10px;"></el-footer>
  </el-container>
</template>

<script>
import axios from '@/assets/axios';

export default {
  data () {
    return {
      activeIndex: '1',
      currentDate: new Date(),
      dianlicount: 13155,
      relicount: 213
    }
  },
  beforeMount(){
    const that = this;
    axios.get('https://wx.hnjt.edu.cn/payinvoiceapp/xlab/visit', {
      params: {
        code: "rr"
      }
    })
    .then(function (response) {
      if (response.status == 200 && response.data.data) {
        that.relicount = response.data.data.visit;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
    axios.get('https://wx.hnjt.edu.cn/payinvoiceapp/xlab/visit', {
      params: {
        code: "gr"
      }
    })
    .then(function (response) {
      if (response.status == 200 && response.data.data) {
        that.dianlicount = response.data.data.visit;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  },
  mounted() {
    sessionStorage.setItem('indexed', "1");
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    loginWarn() {
      this.$notify({
          title: '提示',
          message: '请直接从实验中心的课程目录下的对应虚拟仿真实验课程进入。',
          type: 'success',
          duration: 4000
        });
    },
    regWarn() {
      this.$notify({
          title: '警告',
          message: '未对外开放注册，本校教师和学生请联系实验中心建立账号。',
          type: 'warning',
          duration: 4000
        });
    },
    jumpToLab(path) {
      if (path == '/gaoya/login'){
        window.location.href = "http://aryun.ustcori.com:5210";
      }else{
        this.$router.push({path: path});
      }
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-header {
    /* background-color: #B3C0D1; */
    color: #333;
    text-align: center;
    height: 80px !important;
  }

  .el-footer {
    background-color: #a5bbd8;
    color: #fff;
    text-align: center;
    height: 60px;
    line-height: 60px;
    width: 100%;
    /* position: fixed;
    bottom: 0; */
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .toplogo {
    float: left;
    width: 350px;
    margin-left: 10%;
    line-height: 80px;
    /* background-color: #958ac2; */
    font-size: 16px;
    color:rgb(83, 126, 175)6
  }

  .topimg {
    float: right;
    width: 205px;
    line-height: 80px;
    /* background-color: #9cd68f; */
    margin-bottom: 0;
  }

  .topimg img {
    /* position: relative; */
    /* top: 50%; */
    /* padding-top: 15px; */
    margin-top: 15px;
    border-radius: 6px;
  }

  .topmenu {
    float: right;
    width: 200px;
    margin-right: 10%;
    line-height: 80px;
    /* background-color: #726c8d; */
    font-size: 14px;
    color:#4976e8;
    /* padding-left: 20px; */
  }

  .navimenu {
    float: left;
    line-height: 80px;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 400px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .cardrow {
    width: 80%;
    margin: 0 auto;
    /* line-height: 80px; */
    margin-bottom:  20px;
  }

  .image {
    width: 100%;
    display: block;
    border-radius: 6px;
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 5px;
    line-height: 30px;
  }

  .button {
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/Index.vue